let routerNavigate = null;

export const setRouterNavigate = (navigateFn) => {
  routerNavigate = navigateFn;
};

export const navigate = (to, state) => {
  routerNavigate?.(to, { state });
};
